import React, { useEffect } from 'react';
import { Box, Container, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import qs from 'qs';
import { useLocation } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import alertSnackbarActions from 'src/store/actions/alertSnackbarActions';
import axiosActions from 'src/store/actions/axiosActions';
import Toolbar from './Toolbar';
import Results from './Results';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const AdminListView = ({ axiosGetAdmins, adminList }) => {
  const location = useLocation();
  const classes = useStyles();

  useEffect(() => {
    const { search } = location;
    const queries = qs.parse(search, { ignoreQueryPrefix: true });
    axiosGetAdmins(queries);
  }, [location, axiosGetAdmins]);

  const { users, pagination } = adminList;

  return (
    <Page className={classes.root} title="Admins">
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
          <Results admins={users} pagination={pagination} />
        </Box>
      </Container>
    </Page>
  );
};

AdminListView.propTypes = {
  axiosGetAdmins: PropTypes.func,
  adminList: PropTypes.object
};

const mapStateToProps = (state /* , ownProps */) => {
  return {
    alertSnackbar: state.alertSnackbar,
    adminList: state.adminList
  };
};

const { setOpen, setMessage, setSeverity } = alertSnackbarActions;
const { axiosGetAdmins } = axiosActions;

const mapDispatchToProps = {
  setOpen,
  setMessage,
  setSeverity,
  axiosGetAdmins
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminListView);
